import { createReducer } from "../../util/reducerUtil";
import { FETCH_ACTIVITY, TEST_ATTENDED } from "./UserDetailConstants";

const initialState = {
    fetchActivities: [],
    testAttended: []
};

export const testAttended = (state, payload) => {
    return { ...state, testAttended: payload.testAttended };
};

export const fetchActivities = (state, payload) => {
    return { ...state, fetchActivities: payload.activities };
};

export default createReducer(initialState, {
    [FETCH_ACTIVITY]: fetchActivities,
    [TEST_ATTENDED]: testAttended
});
